module.exports = __webpack_public_path__ + "img/logo-horizontal.9b86b702.png";